import { render, staticRenderFns } from "./priceControl.vue?vue&type=template&id=9081e75a&scoped=true"
import script from "./priceControl.vue?vue&type=script&lang=js"
export * from "./priceControl.vue?vue&type=script&lang=js"
import style0 from "./priceControl.vue?vue&type=style&index=0&id=9081e75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9081e75a",
  null
  
)

export default component.exports